/* empai-bypass-marker-1785966957 */
/**
 * Custom Pieces path (independent of the size dropdown):
 * - reads piece rows
 * - picks best-fit standard sheet (kerf-aware)
 * - updates Your Order (pieces + sheet + cutting fee)
 * - Add pieces to cart → sheet variant + Custom Cut fee together
 */
(function () {
  var SAW_KERF = 0.25;

  function money(amount) {
    var n = Number(amount) || 0;
    return "$" + n.toFixed(2);
  }

  /** Format inches to nearest 1/8" with a readable fraction (e.g. 13.125 → 13 1/8"). */
  function formatInches(n) {
    var value = Number(n);
    if (!isFinite(value) || value < 0) return "0\"";
    var eighths = Math.round(value * 8);
    var whole = Math.floor(eighths / 8);
    var num = eighths % 8;
    if (num === 0) return whole + "\"";
    var den = 8;
    while (num % 2 === 0 && den % 2 === 0) {
      num /= 2;
      den /= 2;
    }
    if (whole === 0) return num + "/" + den + "\"";
    return whole + " " + num + "/" + den + "\"";
  }

  function formatPieceSize(width, length) {
    return formatInches(width) + " × " + formatInches(length);
  }

  function renderPieceLines(root, demands) {
    var host = root.querySelector("[data-cp-piece-lines]");
    if (!host) return;
    var list = Array.isArray(demands) ? demands : [];
    while (host.firstChild) host.removeChild(host.firstChild);

    var header = document.createElement("div");
    header.className = "cp-summary__row cp-summary__row--muted";
    var headerLabel = document.createElement("span");
    headerLabel.textContent = "Pieces";
    var headerCount = document.createElement("span");
    headerCount.className = "cut-count";
    headerCount.textContent = String(
      list.reduce(function (sum, d) {
        return sum + (Number(d.quantity) || 0);
      }, 0),
    );
    header.appendChild(headerLabel);
    header.appendChild(headerCount);
    host.appendChild(header);

    list.forEach(function (d) {
      var row = document.createElement("div");
      row.className = "cp-summary__row cp-summary__row--piece";
      var size = document.createElement("span");
      size.textContent = formatPieceSize(d.width, d.length);
      var qty = document.createElement("span");
      qty.textContent = "× " + String(d.quantity);
      row.appendChild(size);
      row.appendChild(qty);
      host.appendChild(row);
    });
  }

  /** Product JSON prices are cents; tolerate dollar floats if present. */
  function variantPriceDollars(variant) {
    var p = Number(variant && variant.price);
    if (!isFinite(p) || p < 0) return 0;
    if (Number.isInteger(p)) return p / 100;
    return p;
  }

  function getProductJson() {
    var el =
      document.getElementById("ProductJson-product-template") ||
      document.querySelector('[id^="ProductJson-"]') ||
      document.querySelector("script[type='application/json'][id*='ProductJson']");
    if (!el) return null;
    try {
      return JSON.parse(el.textContent);
    } catch (e) {
      try {
        return JSON.parse(el.innerHTML);
      } catch (e2) {
        return null;
      }
    }
  }

  function parseSize(text) {
    if (!text) return null;
    var m = String(text).replace(/inch/gi, "").match(/(\d+(?:\.\d+)?)\s*x\s*(\d+(?:\.\d+)?)/i);
    if (!m) return null;
    return { width: Number(m[1]), length: Number(m[2]) };
  }

  function currentFinishPreference(product) {
    var selects = document.querySelectorAll(".single-option-selector");
    for (var i = 0; i < selects.length; i++) {
      var name = (selects[i].getAttribute("data-name") || "").toLowerCase();
      if (name.indexOf("polish") !== -1 || name.indexOf("edge") !== -1) {
        return selects[i].value || "";
      }
    }
    // fallback: selected variant option2
    var idInput = document.querySelector('form[action*="/cart/add"] [name="id"]');
    var id = idInput && Number(idInput.value);
    if (product && id) {
      for (var v = 0; v < product.variants.length; v++) {
        if (product.variants[v].id === id) return product.variants[v].option2 || "";
      }
    }
    return "No Edge Polishing";
  }

  function maxPiecesAlongAxis(axisLength, pieceLength) {
    if (pieceLength <= 0 || pieceLength > axisLength) return 0;
    return Math.floor((axisLength + SAW_KERF) / (pieceLength + SAW_KERF));
  }

  function orientCutOnSheet(sheet, cutW, cutL) {
    var options = [];
    if (cutW <= sheet.width && cutL <= sheet.length) {
      options.push({
        width: cutW,
        length: cutL,
        perSheet: maxPiecesAlongAxis(sheet.width, cutW) * maxPiecesAlongAxis(sheet.length, cutL),
      });
    }
    if (cutL <= sheet.width && cutW <= sheet.length) {
      options.push({
        width: cutL,
        length: cutW,
        perSheet: maxPiecesAlongAxis(sheet.width, cutL) * maxPiecesAlongAxis(sheet.length, cutW),
      });
    }
    if (!options.length) return null;
    options.sort(function (a, b) {
      return b.perSheet - a.perSheet;
    });
    return options[0];
  }

  function packCutsAcrossSheets(sheet, demands, sheetQty) {
    var orientedCuts = [];
    for (var i = 0; i < demands.length; i++) {
      var oriented = orientCutOnSheet(sheet, demands[i].width, demands[i].length);
      if (!oriented) return false;
      orientedCuts.push({
        width: oriented.width,
        length: oriented.length,
        quantity: demands[i].quantity,
      });
    }

    var allFullWidth = orientedCuts.every(function (cut) {
      return Math.abs(cut.width - sheet.width) < 0.001;
    });

    if (allFullWidth) {
      var pieces = [];
      orientedCuts.forEach(function (cut) {
        for (var q = 0; q < cut.quantity; q++) pieces.push(cut.length);
      });
      pieces.sort(function (a, b) {
        return b - a;
      });
      var bins = [];
      for (var s = 0; s < sheetQty; s++) bins.push({ used: 0, count: 0 });
      for (var p = 0; p < pieces.length; p++) {
        var placed = false;
        for (var b = 0; b < bins.length; b++) {
          var kerf = bins[b].count > 0 ? SAW_KERF : 0;
          if (bins[b].used + kerf + pieces[p] <= sheet.length + 0.001) {
            bins[b].used += kerf + pieces[p];
            bins[b].count++;
            placed = true;
            break;
          }
        }
        if (!placed) return false;
      }
      return true;
    }

    return orientedCuts.every(function (cut) {
      var perSheet =
        maxPiecesAlongAxis(sheet.width, cut.width) * maxPiecesAlongAxis(sheet.length, cut.length);
      return cut.quantity <= perSheet * sheetQty;
    });
  }

  function readRowQuantity(row) {
    var qtyInput =
      row.querySelector(".product-form__item--quantity .js-qty__input") ||
      row.querySelector(".product-form__item--quantity .product-form__quantity") ||
      row.querySelector(".product-form__quantity.cut-input") ||
      row.querySelector(".product-form__item--quantity input[type='number']") ||
      row.querySelector(".js-qty__input");
    return Number(qtyInput && qtyInput.value) || 0;
  }

  function readDemands(root) {
    var demands = [];
    var rows = root.querySelectorAll(".cut-item");
    if (!rows.length) rows = root.querySelectorAll(".cut-items > div");
    for (var i = 0; i < rows.length; i++) {
      var row = rows[i];
      var width = Number(row.querySelector(".product-form__width") && row.querySelector(".product-form__width").value) || 0;
      var length = Number(row.querySelector(".product-form__length") && row.querySelector(".product-form__length").value) || 0;
      var fw = Number(row.querySelector(".fraction__width") && row.querySelector(".fraction__width").value) || 0;
      var fl = Number(row.querySelector(".fraction__length") && row.querySelector(".fraction__length").value) || 0;
      var quantity = readRowQuantity(row);
      width += fw;
      length += fl;
      if (width > 0 && length > 0 && quantity > 0) {
        demands.push({ width: width, length: length, quantity: quantity, row: row });
      }
    }
    return demands;
  }

  function commitRowCutData(demand) {
    var row = demand.row;
    var cutData = row.querySelector(".cut-data");
    if (!cutData) return;
    cutData.setAttribute(
      "name",
      "properties[Custom Cut: " + demand.width + " X " + demand.length + "]",
    );
    cutData.value = String(demand.quantity);
  }

  function clearRowCutData(row) {
    var cutData = row.querySelector(".cut-data");
    if (!cutData) return;
    cutData.setAttribute("name", "properties[Custom Cut: 0 X 0]");
    cutData.value = "0";
  }

  function listVariantSheetCandidates(product, finishPref) {
    var out = [];
    for (var i = 0; i < product.variants.length; i++) {
      var v = product.variants[i];
      if (v.available === false) continue;
      var size = parseSize(v.option1 || v.title);
      if (!size) continue;
      var finish = v.option2 || "";
      // Prefer matching finish; still keep others as fallback
      out.push({
        id: v.id,
        title: v.title,
        price: variantPriceDollars(v),
        width: size.width,
        length: size.length,
        area: size.width * size.length,
        finish: finish,
        finishMatch: !finishPref || !finish || finish === finishPref,
      });
    }
    return out;
  }

  function getEmpaiLinking() {
    var el =
      document.querySelector("[data-empai-linking]") ||
      document.querySelector(".empai-linked-picker[data-empai-linking]");
    if (!el) return null;
    var raw = el.getAttribute("data-empai-linking");
    if (!raw) return null;
    try {
      return JSON.parse(raw);
    } catch (e) {
      return null;
    }
  }

  function normKey(v) {
    return String(v || "")
      .trim()
      .toLowerCase();
  }

  function packQty(v) {
    var n = Number(v);
    return Number.isFinite(n) && n > 0 ? n : 1;
  }

  /** EmpAI catalog: one product per size — sizes live in linking siblings, not variants. */
  function currentProductAsCandidate(product, linking) {
    if (!product || !product.variants || !product.variants.length) return null;
    var sizeText =
      (linking && linking.size) ||
      product.title ||
      "";
    var size = parseSize(sizeText);
    if (!size) return null;
    var v = null;
    for (var i = 0; i < product.variants.length; i++) {
      if (product.variants[i].available !== false) {
        v = product.variants[i];
        break;
      }
    }
    if (!v) v = product.variants[0];
    if (!v || v.available === false) return null;
    return {
      id: v.id,
      title: product.title || v.title,
      price: variantPriceDollars(v),
      width: size.width,
      length: size.length,
      area: size.width * size.length,
      finish: v.option2 || "",
      finishMatch: true,
      handle: product.handle || "",
    };
  }

  var empaiSheetCatalog = null;
  var empaiSheetCatalogKey = "";
  var empaiSheetCatalogPromise = null;

  function linkingSheetKey(linking) {
    if (!linking) return "";
    return normKey(linking.color) + "|" + normKey(linking.thickness);
  }

  function siblingHandlesForSheets(linking) {
    if (!linking || !Array.isArray(linking.siblings)) return [];
    var color = normKey(linking.color);
    var thickness = normKey(linking.thickness);
    var handles = [];
    var seen = {};
    linking.siblings.forEach(function (s) {
      if (!s || !s.handle) return;
      if (color && normKey(s.color) !== color) return;
      if (thickness && normKey(s.thickness) !== thickness) return;
      // Standard stock sheets are singles (qty 1), not multipacks
      if (packQty(s.quantity) !== 1) return;
      if (!parseSize(s.size)) return;
      var h = String(s.handle);
      if (seen[h]) return;
      seen[h] = true;
      handles.push(h);
    });
    return handles;
  }

  function candidateFromProductJs(data) {
    if (!data || !data.variants || !data.variants.length) return null;
    var size = parseSize(data.title) || null;
    if (!size && data.tags) {
      var tags = Array.isArray(data.tags) ? data.tags : String(data.tags).split(",");
      for (var t = 0; t < tags.length; t++) {
        var tag = String(tags[t] || "").trim();
        if (/^size:/i.test(tag)) {
          size = parseSize(tag.slice(5));
          if (size) break;
        }
      }
    }
    if (!size) return null;
    var v = null;
    for (var i = 0; i < data.variants.length; i++) {
      if (data.variants[i].available !== false) {
        v = data.variants[i];
        break;
      }
    }
    if (!v) return null;
    return {
      id: v.id,
      title: data.title || v.title,
      price: variantPriceDollars(v),
      width: size.width,
      length: size.length,
      area: size.width * size.length,
      finish: v.option2 || "",
      finishMatch: true,
      handle: data.handle || "",
    };
  }

  function ensureEmpaiSheetCatalog(linking) {
    var key = linkingSheetKey(linking);
    if (!key) return Promise.resolve([]);
    if (empaiSheetCatalog && empaiSheetCatalogKey === key) {
      return Promise.resolve(empaiSheetCatalog);
    }
    if (empaiSheetCatalogPromise && empaiSheetCatalogKey === key) {
      return empaiSheetCatalogPromise;
    }
    var handles = siblingHandlesForSheets(linking);
    if (!handles.length) {
      empaiSheetCatalog = [];
      empaiSheetCatalogKey = key;
      return Promise.resolve(empaiSheetCatalog);
    }
    empaiSheetCatalogKey = key;
    empaiSheetCatalogPromise = Promise.all(
      handles.map(function (handle) {
        return fetch("/products/" + encodeURIComponent(handle) + ".js", {
          credentials: "same-origin",
        })
          .then(function (r) {
            if (!r.ok) return null;
            return r.json();
          })
          .then(candidateFromProductJs)
          .catch(function () {
            return null;
          });
      }),
    ).then(function (rows) {
      empaiSheetCatalog = rows.filter(Boolean);
      empaiSheetCatalogPromise = null;
      return empaiSheetCatalog;
    });
    return empaiSheetCatalogPromise;
  }

  function mergeCandidates(primary, extra) {
    var out = (primary || []).slice();
    var seen = {};
    out.forEach(function (c) {
      seen[String(c.id)] = true;
    });
    (extra || []).forEach(function (c) {
      if (!c || seen[String(c.id)]) return;
      seen[String(c.id)] = true;
      out.push(c);
    });
    return out;
  }

  function listSheetCandidates(product, finishPref) {
    var out = listVariantSheetCandidates(product, finishPref);
    var linking = getEmpaiLinking();
    if (empaiSheetCatalog && empaiSheetCatalogKey === linkingSheetKey(linking)) {
      out = mergeCandidates(out, empaiSheetCatalog);
    }
    if (!out.length) {
      var current = currentProductAsCandidate(product, linking);
      if (current) out.push(current);
    }
    return out;
  }

  function approxEq(a, b) {
    return Math.abs(Number(a) - Number(b)) < 0.001;
  }

  function dimsMatchSheet(w, l, sheet) {
    return (
      (approxEq(w, sheet.width) && approxEq(l, sheet.length)) ||
      (approxEq(w, sheet.length) && approxEq(l, sheet.width))
    );
  }

  /** Exact standard sheet match for a piece (no cutting needed). */
  function findExactSheetCandidate(w, l, candidates) {
    var preferred = candidates.filter(function (c) {
      return c.finishMatch && dimsMatchSheet(w, l, c);
    });
    var pool = preferred.length
      ? preferred
      : candidates.filter(function (c) {
          return dimsMatchSheet(w, l, c);
        });
    if (!pool.length) return null;
    pool.sort(function (a, b) {
      return a.price - b.price;
    });
    return pool[0];
  }

  /**
   * If every piece line is an exact standard sheet size, sell whole sheets
   * with no cutting fee. Supports one or more sheet SKUs.
   */
  function findStandardSheetsOrder(demands, candidates) {
    if (!demands.length) return null;
    var lines = [];
    var totalPrice = 0;
    var totalSheets = 0;
    for (var i = 0; i < demands.length; i++) {
      var d = demands[i];
      var match = findExactSheetCandidate(d.width, d.length, candidates);
      if (!match) return null;
      lines.push({
        variantId: match.id,
        quantity: d.quantity,
        title: match.title,
        unitPrice: match.price,
        candidate: match,
      });
      totalPrice += match.price * d.quantity;
      totalSheets += d.quantity;
    }
    // Merge same variant ids
    var merged = {};
    lines.forEach(function (line) {
      if (!merged[line.variantId]) {
        merged[line.variantId] = {
          variantId: line.variantId,
          quantity: 0,
          title: line.title,
          unitPrice: line.unitPrice,
          candidate: line.candidate,
        };
      }
      merged[line.variantId].quantity += line.quantity;
    });
    var sheetItems = Object.keys(merged).map(function (k) {
      return merged[k];
    });
    var primary = sheetItems[0];
    return {
      isStandardSize: true,
      candidate: primary.candidate,
      sheetQty: primary.quantity,
      totalPrice: totalPrice,
      totalSheets: totalSheets,
      sheetItems: sheetItems,
    };
  }

  function findBestFit(demands, candidates) {
    if (!demands.length || !candidates.length) return null;

    var preferred = candidates.filter(function (c) {
      return c.finishMatch;
    });
    var pools = preferred.length ? [preferred, candidates] : [candidates];

    for (var p = 0; p < pools.length; p++) {
      var pool = pools[p].slice();
      // cheapest adequate sheet qty first, then smaller area, then cheaper
      var fits = [];
      for (var i = 0; i < pool.length; i++) {
        var c = pool[i];
        var sheet = { width: c.width, length: c.length };
        // quick reject: every piece must orient on this sheet
        var canOrient = demands.every(function (d) {
          return !!orientCutOnSheet(sheet, d.width, d.length);
        });
        if (!canOrient) continue;

        var sheetQty = 0;
        for (var q = 1; q <= 20; q++) {
          if (packCutsAcrossSheets(sheet, demands, q)) {
            sheetQty = q;
            break;
          }
        }
        if (!sheetQty) continue;
        fits.push({
          candidate: c,
          sheetQty: sheetQty,
          totalPrice: c.price * sheetQty,
          isStandardSize: false,
        });
      }
      if (!fits.length) continue;
      fits.sort(function (a, b) {
        if (a.totalPrice !== b.totalPrice) return a.totalPrice - b.totalPrice;
        if (a.sheetQty !== b.sheetQty) return a.sheetQty - b.sheetQty;
        return a.candidate.area - b.candidate.area;
      });
      return fits[0];
    }
    return null;
  }

  function cutFeeEach() {
    var el = document.getElementById("cut-to-size-price");
    var cents = el ? Number(el.getAttribute("data-price")) : 350;
    if (!cents) cents = 350;
    // liquid money data-price is usually cents
    return cents > 50 ? cents / 100 : cents;
  }

  function showMessage(root, className, text) {
    root.querySelectorAll(".cut-message").forEach(function (el) {
      el.classList.remove("active");
    });
    var el = root.querySelector(className);
    if (!el) return;
    if (text) el.textContent = text;
    el.classList.add("active");
  }

  function clearMessages(root) {
    var scope = root || document;
    scope.querySelectorAll(".cut-message").forEach(function (el) {
      el.classList.remove("active");
      // Drop stale legacy Size-dropdown errors on EmpAI catalog PDPs
      if (
        el.classList.contains("cut-size-error") &&
        /Could not read the selected sheet size/i.test(el.textContent || "")
      ) {
        el.textContent = "The width or length is too big.";
      }
    });
  }

  function updateSummary(root, state) {
    var pieceCount = state.pieceCount || 0;
    var sheetSub = state.sheetSubtotal || 0;
    var fee = state.fee || 0;
    renderPieceLines(root, state.demands || []);
    root.querySelectorAll(".cut-count").forEach(function (el) {
      el.textContent = String(pieceCount);
    });
    root.querySelectorAll(".cut-sheet-subtotal").forEach(function (el) {
      el.textContent = money(sheetSub);
    });
    root.querySelectorAll(".cut-subtotal").forEach(function (el) {
      el.textContent = money(fee);
    });
    root.querySelectorAll(".cut-total").forEach(function (el) {
      el.textContent = money(sheetSub + fee);
    });

    var label = root.querySelector(".cp-variant-label");
    var priceEl = root.querySelector(".cp-sheet-price");
    var fitEl = root.querySelector("[data-cp-fit-status]");
    var feeRow = root.querySelector("[data-cp-fee-row]");
    if (feeRow) feeRow.hidden = fee <= 0 && !!state.fit && !!state.fit.isStandardSize;

    if (state.fit) {
      if (label) {
        if (state.fit.isStandardSize && state.fit.sheetItems && state.fit.sheetItems.length > 1) {
          label.textContent = state.fit.sheetItems
            .map(function (l) {
              return l.title + " × " + l.quantity;
            })
            .join(", ");
        } else {
          label.textContent =
            state.fit.candidate.title +
            (state.fit.sheetQty > 1 ? " × " + state.fit.sheetQty : "");
        }
      }
      if (priceEl) {
        priceEl.textContent = state.fit.isStandardSize
          ? money(sheetSub)
          : money(state.fit.candidate.price);
      }
      if (fitEl) {
        fitEl.textContent = state.fit.isStandardSize
          ? "Standard sheet size — no cutting charge."
          : "Custom cut — best-fit sheet selected (accounts for 1/4\" saw blade).";
        fitEl.hidden = false;
      }
    } else if (!pieceCount) {
      if (fitEl) {
        fitEl.textContent = "";
        fitEl.hidden = true;
      }
      if (feeRow) feeRow.hidden = false;
    } else if (fitEl) {
      fitEl.textContent = state.error || "No standard sheet fits these pieces.";
      fitEl.hidden = false;
    }

    var btn = root.querySelector("[data-cp-add-pieces]");
    if (btn) btn.disabled = !(state.fit && pieceCount > 0);
    window.__falkenPiecesOrder = state.fit
      ? {
          sheetVariantId: state.fit.candidate.id,
          sheetQuantity: state.fit.sheetQty,
          cutFeeQuantity: state.fit.isStandardSize ? 0 : pieceCount,
          properties: state.fit.isStandardSize ? {} : state.properties || {},
          sheetItems: state.fit.sheetItems || null,
          isStandardSize: !!state.fit.isStandardSize,
          pieceCount: pieceCount,
          sheetSubtotal: sheetSub,
          fee: fee,
        }
      : null;
  }

  function buildProperties(demands) {
    var props = {};
    demands.forEach(function (d) {
      var key = "Custom Cut: " + d.width + " X " + d.length;
      props[key] = String(d.quantity);
    });
    return props;
  }

  function applyFitFromCandidates(root, product, demands, candidates) {
    var pieceCount = demands.reduce(function (sum, d) {
      return sum + d.quantity;
    }, 0);
    var finish = currentFinishPreference(product);
    // Re-merge in case finish filter / sync fallback needed
    candidates = mergeCandidates(candidates, listSheetCandidates(product, finish));

    if (!candidates.length) {
      showMessage(
        root,
        ".cut-size-error",
        "No standard sheet sizes found on this product.",
      );
      updateSummary(root, {
        pieceCount: pieceCount,
        sheetSubtotal: 0,
        fee: 0,
        fit: null,
        demands: demands,
        error: "No sheet sizes available.",
      });
      return;
    }

    // Exact standard sheet sizes → whole sheets, $0 cutting
    var standard = findStandardSheetsOrder(demands, candidates);
    if (standard) {
      // Clear cut properties — these are full sheets, not custom cuts
      root.querySelectorAll(".cut-item").forEach(clearRowCutData);
      neutralizeLegacyCutErrors(root);
      window.setTimeout(function () { neutralizeLegacyCutErrors(root); }, 0);
      window.setTimeout(function () { neutralizeLegacyCutErrors(root); }, 100);
      updateSummary(root, {
        pieceCount: pieceCount,
        sheetSubtotal: standard.totalPrice,
        fee: 0,
        fit: standard,
        demands: demands,
        properties: {},
      });
      return;
    }

    var fit = findBestFit(demands, candidates);

    if (!fit) {
      showMessage(
        root,
        ".cut-size-error",
        "These pieces do not fit any standard sheet size (including 1/4\" saw blade). Try smaller pieces or fewer pieces.",
      );
      updateSummary(root, {
        pieceCount: pieceCount,
        sheetSubtotal: 0,
        fee: 0,
        fit: null,
        demands: demands,
        error: "No sheet fits — adjust piece size/qty.",
      });
      return;
    }

    neutralizeLegacyCutErrors(root);
    window.setTimeout(function () { neutralizeLegacyCutErrors(root); }, 0);
    window.setTimeout(function () { neutralizeLegacyCutErrors(root); }, 100);
    var feeEach = cutFeeEach();
    updateSummary(root, {
      pieceCount: pieceCount,
      sheetSubtotal: fit.totalPrice,
      fee: pieceCount * feeEach,
      fit: fit,
      demands: demands,
      properties: buildProperties(demands),
    });
  }

  function recalculate(root) {
    var demands = readDemands(root);
    var pieceCount = demands.reduce(function (sum, d) {
      return sum + d.quantity;
    }, 0);

    // Always sync cut-data from filled rows so cart properties stay correct
    root.querySelectorAll(".cut-item").forEach(function (row) {
      clearRowCutData(row);
    });
    demands.forEach(commitRowCutData);

    if (!pieceCount) {
      clearMessages(root);
      updateSummary(root, { pieceCount: 0, sheetSubtotal: 0, fee: 0, fit: null, demands: [] });
      return;
    }

    var product = getProductJson();
    if (!product || !product.variants || !product.variants.length) {
      showMessage(
        root,
        ".cut-size-error",
        "Could not load sheet sizes for this product. Please refresh the page.",
      );
      updateSummary(root, {
        pieceCount: pieceCount,
        sheetSubtotal: 0,
        fee: 0,
        fit: null,
        demands: demands,
        error: "Product data missing — refresh and try again.",
      });
      return;
    }

    var linking = getEmpaiLinking();
    var finish = currentFinishPreference(product);
    var candidates = listSheetCandidates(product, finish);

    // EmpAI catalog products: hydrate sibling sheet sizes (async), then re-fit
    if (linking && siblingHandlesForSheets(linking).length) {
      ensureEmpaiSheetCatalog(linking).then(function (extra) {
        if (!root.isConnected) return;
        // Only apply if piece inputs haven't changed mid-flight
        var latest = readDemands(root);
        if (latest.length !== demands.length) {
          recalculate(root);
          return;
        }
        applyFitFromCandidates(root, product, latest, mergeCandidates(candidates, extra));
      });
    }

    if (!candidates.length) {
      // Waiting on sibling fetch — show soft loading state, not a hard error
      if (linking && siblingHandlesForSheets(linking).length) {
        updateSummary(root, {
          pieceCount: pieceCount,
          sheetSubtotal: 0,
          fee: 0,
          fit: null,
          demands: demands,
          error: "Loading sheet sizes…",
        });
        return;
      }
      showMessage(
        root,
        ".cut-size-error",
        "No standard sheet sizes found on this product.",
      );
      updateSummary(root, {
        pieceCount: pieceCount,
        sheetSubtotal: 0,
        fee: 0,
        fit: null,
        demands: demands,
        error: "No sheet sizes available.",
      });
      return;
    }

    applyFitFromCandidates(root, product, demands, candidates);
  }

  function addPiecesToCart(root) {
    var order = window.__falkenPiecesOrder;
    if (!order || !order.sheetVariantId) {
      alert("Enter valid pieces that fit a standard sheet first.");
      return;
    }
    if (typeof window.falkenAddCustomPiecesOrder !== "function") {
      alert("Cart helper not loaded. Please refresh and try again.");
      return;
    }
    var btn = root.querySelector("[data-cp-add-pieces]");
    if (btn) btn.disabled = true;
    var payload = {
      sheetVariantId: order.sheetVariantId,
      sheetQuantity: order.sheetQuantity,
      cutFeeQuantity: order.cutFeeQuantity || 0,
      properties: order.properties || {},
    };
    if (order.sheetItems && order.sheetItems.length) {
      payload.sheetItems = order.sheetItems.map(function (l) {
        return { id: l.variantId, quantity: l.quantity };
      });
    }
    window.falkenAddCustomPiecesOrder(payload, {
      onSuccess: function () {
        if (btn) btn.disabled = false;
        // clear piece rows
        var clearBtn = root.querySelector(".clear--cut-size-item");
        if (clearBtn) clearBtn.click();
        recalculate(root);
      },
      onError: function () {
        if (btn) btn.disabled = false;
        alert("Could not add to cart. Please try again.");
      },
    });
  }


  function neutralizeLegacyCutErrors(root) {
    clearMessages(root);
    // Legacy cut-fix may re-show Size-dropdown errors after our fit succeeds.
    window.falkenValidateCutItem = function () { return true; };
    window.falkenValidateAllCuts = function (showErrors) {
      var r = document.querySelector(".cut-container--pieces");
      if (!r) return true;
      recalculate(r);
      var order = window.__falkenPiecesOrder;
      return !!(order && order.sheetVariantId && order.pieceCount > 0);
    };
  }

  function installValidationBypass() {
    // Pieces path validates via auto-fit, not the dropdown sheet.
    var prev = window.falkenValidateAllCuts;
    window.falkenValidateAllCuts = function (showErrors) {
      var root = document.querySelector(".cut-container--pieces");
      if (!root) return prev ? prev(showErrors) : true;
      recalculate(root);
      var order = window.__falkenPiecesOrder;
      if (order && order.sheetVariantId && order.pieceCount > 0) return true;
      if (showErrors) {
        var demands = readDemands(root);
        if (!demands.length) {
          showMessage(root, ".cut-error", "Please fill width, length, and quantity for your pieces.");
        }
      }
      return false;
    };

    // Stop legacy/kerf pricing from zeroing Your Order against the dropdown sheet.
    function installCalcPatch() {
      if (window.calcPriceWithCutItems && window.calcPriceWithCutItems.__falkenPiecesPatched) return;
      var prevCalc = window.calcPriceWithCutItems;
      window.calcPriceWithCutItems = function () {
        var root = document.querySelector(".cut-container--pieces");
        if (root) {
          recalculate(root);
          return;
        }
        if (typeof prevCalc === "function" && !prevCalc.__falkenPiecesPatched) {
          return prevCalc.apply(this, arguments);
        }
      };
      // Claim both flags so falken-custom-cut-form.js won't overwrite us later.
      window.calcPriceWithCutItems.__falkenPiecesPatched = true;
      window.calcPriceWithCutItems.__falkenPatched = true;
    }
    installCalcPatch();
    window.setTimeout(installCalcPatch, 500);
    window.setTimeout(installCalcPatch, 2000);
    window.setTimeout(installCalcPatch, 4000);
  }

  function bind(root) {
    var schedule = null;
    function kick() {
      window.clearTimeout(schedule);
      schedule = window.setTimeout(function () {
        recalculate(root);
      }, 50);
    }

    root.addEventListener("input", kick, true);
    root.addEventListener("change", kick, true);
    root.addEventListener(
      "click",
      function (event) {
        var t = event.target;
        if (!t) return;
        if (t.closest && t.closest(".js-qty__adjust, .cut-input, .fraction__width, .fraction__length")) {
          window.setTimeout(kick, 0);
          window.setTimeout(kick, 80);
        }
      },
      true,
    );
    var items = root.querySelector(".cut-items");
    if (items) {
      var mo = new MutationObserver(kick);
      mo.observe(items, { childList: true, subtree: true });
    }

    var addBtn = root.querySelector("[data-cp-add-pieces]");
    if (addBtn) {
      addBtn.addEventListener("click", function (e) {
        e.preventDefault();
        e.stopPropagation();
        recalculate(root);
        addPiecesToCart(root);
      });
    }

    // Prefer No Edge Polishing facts label until pieces drive fit
    kick();
  }

  function init() {
    var root = document.querySelector(".cut-container--pieces");
    if (!root || root.__falkenPiecesBound) return;
    root.__falkenPiecesBound = true;
    installValidationBypass();
    neutralizeLegacyCutErrors(root);
    bind(root);
  }

  if (document.readyState === "loading") {
    document.addEventListener("DOMContentLoaded", init);
  } else {
    init();
  }
  window.addEventListener("load", init);
  window.setTimeout(init, 300);
  window.setTimeout(init, 1200);
})();
